import React, { useState } from 'react';
import { Eye, EyeOff, Wifi, Server, Info, AlertCircle } from 'lucide-react';
import WebStepShell from './WebStepShell';
import DeviceMedia from './DeviceMedia';
import type { WebFlowCtx } from './types';

interface Props {
  ctx: WebFlowCtx;
}

const Step2WifiServer: React.FC<Props> = ({ ctx }) => {
  const [showPassword, setShowPassword] = useState(false);
  const { validationErrors } = ctx;

  return (
    <WebStepShell
      step="wificonf"
      onHeaderBack={ctx.openExitModal}
      onCancel={ctx.openExitModal}
      secondary={{ label: 'Back', onClick: ctx.goBack }}
      primary={{ label: 'Next', onClick: ctx.verify }}
      media={<DeviceMedia indicator="step1" />}
    >
      <p className="dcfw-eyebrow">SETUP PHASE 2</p>
      <h2 className="dcfw-title">Step 2 of 6: Enter Wi-Fi and server details</h2>

      <div className="dcf-field" style={{ marginTop: 12 }}>
        <label className="dcf-field__label">Wi-Fi Network Name (SSID) <span className="text-red-500">*</span></label>
        <div className="dcf-field__input-wrap">
          <input
            type="text"
            className="dcf-field__input dcf-field__input--with-icon"
            placeholder="Enter network name"
            value={ctx.wifiname}
            onChange={(e) => ctx.setWifiName(e.target.value)}
          />
          <span className="dcf-field__icon-btn" aria-hidden="true">
            <Wifi size={18} />
          </span>
        </div>
        {validationErrors.wifiname && (
          <span className="dcf-field__error">
            <AlertCircle size={12} /> {validationErrors.wifiname}
          </span>
        )}
      </div>

      <div className="dcf-field">
        <label className="dcf-field__label">Wi-Fi Password <span className="text-red-500">*</span></label>
        <div className="dcf-field__input-wrap">
          <input
            type={showPassword ? 'text' : 'password'}
            className="dcf-field__input dcf-field__input--with-icon"
            placeholder="Enter password"
            value={ctx.wifipassword}
            onChange={(e) => ctx.setWifiPassword(e.target.value)}
          />
          <button
            type="button"
            className="dcf-field__icon-btn"
            onClick={() => setShowPassword((s) => !s)}
            aria-label={showPassword ? 'Hide password' : 'Show password'}
          >
            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        </div>
        {validationErrors.password && (
          <span className="dcf-field__error">
            <AlertCircle size={12} /> {validationErrors.password}
          </span>
        )}
      </div>

      <div className="dcf-field">
        <label className="dcf-field__label">Server URL</label>
        <div className="dcf-field__input-wrap">
          <input
            type="text"
            className="dcf-field__input dcf-field__input--with-icon"
            value={ctx.serverUrl}
            onChange={(e) => ctx.setServerUrl(e.target.value)}
          />
          <span className="dcf-field__icon-btn" aria-hidden="true">
            <Server size={18} />
          </span>
        </div>
        <span className="dcf-field__hint dcf-field__hint--muted">
          Verify this URL matches your regional hub.
        </span>
      </div>

      <div className="dcf-banner">
        <Info size={20} color="#EEC94D" className="flex-shrink-0" />
        <div className="dcf-banner-description">
          <span>
            Kindly note that device connects with only 2.4GHz connection, so
            please select or connect with a 2.4GHz internet connection only.
          </span>
        </div>
      </div>
    </WebStepShell>
  );
};

export default Step2WifiServer;
